// Generated by purs version 0.14.3
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Error_Class = require("../Control.Monad.Error.Class/index.js");
var Control_Monad_Except = require("../Control.Monad.Except/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Aff_Compat = require("../Effect.Aff.Compat/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic = require("../Foreign.Generic/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Network_Ethereum_Web3_Types_Types = require("../Network.Ethereum.Web3.Types.Types/index.js");
var Remote = function (remote_) {
    this.remote_ = remote_;
};
var remote_ = function (dict) {
    return dict.remote_;
};
var remoteInductive = function (dictEncode) {
    return function (dictRemote) {
        return new Remote(function (f) {
            return function (x) {
                return remote_(dictRemote)(function (p) {
                    return function (args) {
                        return f(p)(Data_Array.cons(Foreign_Generic_Class.encode(dictEncode)(x))(args));
                    };
                });
            };
        });
    };
};
var remoteBase = function (dictDecode) {
    return new Remote(function (f) {
        var asError = function (e) {
            return Effect_Exception.error(Foreign_Generic.genericEncodeJSON(Network_Ethereum_Web3_Types_Types.genericWeb3Error)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "Rpc";
            }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Network_Ethereum_Web3_Types_Types.encodeRpcError))))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "RemoteError";
            }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "ParserError";
            }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "NullError";
            }))(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))(Foreign_Generic_Class.defaultOptions)(e));
        };
        return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Control_Monad_Reader_Class.ask(Network_Ethereum_Web3_Types_Types.monadAskWeb3))(function (p) {
            return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Effect_Aff_Class.liftAff(Network_Ethereum_Web3_Types_Types.monadAffWeb3)(Effect_Aff.attempt(f(p)(Data_Monoid.mempty(Data_Monoid.monoidArray)))))(function (res$prime) {
                if (res$prime instanceof Data_Either.Left) {
                    return Control_Monad_Error_Class.throwError(Network_Ethereum_Web3_Types_Types.monadThrowWeb3)(asError(Network_Ethereum_Web3_Types_Types.RemoteError.create(Data_Show.show(Effect_Exception.showError)(res$prime.value0))));
                };
                if (res$prime instanceof Data_Either.Right) {
                    var v = Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(Network_Ethereum_Web3_Types_Types["decodeResponse'"](dictDecode))(res$prime.value0));
                    if (v instanceof Data_Either.Left) {
                        return Control_Monad_Error_Class.throwError(Network_Ethereum_Web3_Types_Types.monadThrowWeb3)(asError(Network_Ethereum_Web3_Types_Types.ParserError.create(Data_Show.show(Data_List_Types.showNonEmptyList(Foreign.showForeignError))(v.value0))));
                    };
                    if (v instanceof Data_Either.Right) {
                        if (v.value0 instanceof Data_Either.Left) {
                            return Control_Monad_Error_Class.throwError(Network_Ethereum_Web3_Types_Types.monadThrowWeb3)(asError(v.value0.value0));
                        };
                        if (v.value0 instanceof Data_Either.Right) {
                            return Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(v.value0.value0);
                        };
                        throw new Error("Failed pattern match at Network.Ethereum.Web3.JsonRPC (line 34, column 31 - line 36, column 28): " + [ v.value0.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Network.Ethereum.Web3.JsonRPC (line 31, column 20 - line 36, column 28): " + [ v.constructor.name ]);
                };
                throw new Error("Failed pattern match at Network.Ethereum.Web3.JsonRPC (line 29, column 5 - line 36, column 28): " + [ res$prime.constructor.name ]);
            });
        });
    });
};
var remote = function (dictRemote) {
    return function (n) {
        return remote_(dictRemote)(function (provider) {
            return function (ps) {
                return Effect_Aff_Compat.fromEffectFnAff($foreign["_sendAsync"](provider)(Network_Ethereum_Web3_Types_Types.mkRequest(n)(1)(ps)));
            };
        });
    };
};
module.exports = {
    remote_: remote_,
    Remote: Remote,
    remote: remote,
    remoteBase: remoteBase,
    remoteInductive: remoteInductive,
    "_sendAsync": $foreign["_sendAsync"]
};
